'use client';

import React from 'react';

interface TargetBadgeProps {
  target: number;
  testId?: string;
}

const TargetBadge: React.FC<TargetBadgeProps> = ({ target, testId = 'target-badge' }) => (
  <span
    className="inline-flex items-center rounded-full bg-neutral-50 px-2.5 py-0.5 text-xs font-medium text-neutral-700"
    data-testid={testId}
  >
    Target = {target % 1 === 0 ? target.toFixed(1) : target.toString()}
  </span>
);

export default TargetBadge;
